/** Shared restriction level union (Project / Social Order / Growth Tool). */
export type RestrictionLevel = 'full' | 'comments'

export const RESTRICTION_LEVELS: readonly RestrictionLevel[] = ['full', 'comments'] as const

export const RESTRICTION_COMMENTS_LABEL = 'Запретить комментирование'

/** Entity-specific label for `full`; comments label is shared. */
export function buildRestrictionLevelLabels(
  fullLabel: string,
): Record<RestrictionLevel, string> {
  return {
    full: fullLabel,
    comments: RESTRICTION_COMMENTS_LABEL,
  }
}
